import classNames from 'classnames';

import styles from './Tail.module.css';

import { Color } from '../../styles';

interface TailProps {
  color?: 'kale' | 'carrot' | 'white';
  position?: 'start' | 'end';
}

export const Tail = ({ color = 'kale', position = 'start' }: TailProps) => {
  const colorFillMap: Record<
    Exclude<TailProps['color'], undefined>,
    { borderFill: Color | 'transparent'; backgroundFill: Color }
  > = {
    white: {
      borderFill: Color.Carrot2,
      backgroundFill: Color.White,
    },
    carrot: {
      borderFill: Color.Carrot3,
      backgroundFill: Color.Carrot0,
    },
    kale: {
      borderFill: 'transparent',
      backgroundFill: Color.Kale0,
    },
  };

  const className = classNames(styles[position], styles.arrow, styles[color]);
  const { backgroundFill, borderFill } = colorFillMap[color];

  return (
    <div data-testid="tail" className={className}>
      <svg width="21px" height="22px" viewBox="0 0 21 22">
        <polygon
          fill={backgroundFill}
          points="20 22 15.3680711 2 0.981886497 22"
        />
        <polygon
          fill={borderFill}
          points="15.9229392 0 16.1701936 1.06602134 21 22 20.020686 22 15.4371156 2.3536253 0.981886497 22 -1.16573418e-15 22 15.2731164 0.885969465"
        />
      </svg>
    </div>
  );
};
